import React from 'react'
import { DataTable } from 'primereact/datatable'
import { Column, ColumnBodyOptions } from 'primereact/column'
import classes from './LinkedProductsV2.module.scss'
const linkedProductsColumn = [
  {
    id: 'modelName',
    value: 'Model Name',
  },
  {
    id: 'productType',
    value: 'Product Type',
  },
]

interface LinkedProductsV2Props {
  products: any
}

const LinkedProductsV2 = (props: LinkedProductsV2Props) => {
  const renderColumnData = (props: any, options: ColumnBodyOptions) => {
    return (
      <span title={props[options.field]} className={`${classes['table-cell-item__span']}`}>
        {props[options.field]}
      </span>
    )
  }

  return (
    <div
      className={`${classes['certificate-linked-products__container']}`}
      style={{ padding: '0rem' }}
    >
      <div className={`ul-grid__row`}>
        <div className={`ul-grid__column -x100`}>
          <DataTable
            removableSort
            value={props.products}
            dataKey="id"
            tableStyle={{
              position: 'relative',
              width: '100%',
            }}
            scrollHeight={props.products?.length > 10 ? '20rem' : ''}
            scrollable={props.products?.length > 10}
            style={{ border: '1px solid #dee2e6' }}
          >
            {linkedProductsColumn.map(col => (
              <Column
                key={col.id}
                columnKey={col.id}
                body={renderColumnData}
                field={col.id}
                header={col.value}
                style={{ fontSize: 14 }}
                bodyStyle={{ display: 'table-cell' }}
                bodyClassName="text-container-ellipsis"
              />
            ))}
          </DataTable>
        </div>
      </div>
    </div>
  )
}

export default LinkedProductsV2
